import PageMetaTags from "./PageMetaTags";

export default PageMetaTags;
